const IconKitchenTips = (): JSX.Element => {
  return (
    <>
      <g clipPath="url(#clip0_19334_33)">
        <path
          d="M14.3359 1.27333C15.1124 0.49685 18.2185 -1.05629 22.1008 2.82588C25.2068 5.93184 22.8775 9.81482 21.3246 11.3678L9.67754 23.7911L0.359375 16.0262C1.39474 14.7319 3.77611 11.5229 5.01847 9.03824C6.57143 5.93232 6.5712 1.27293 8.9006 0.496337C12.0066 -0.538984 10.7127 4.37923 10.4538 6.70869C11.489 5.15592 13.7144 1.89513 14.3359 1.27333ZM10.2337 14.3422L8.27056 11.6966L6.5071 13.0056L9.77914 17.4147L16.2933 10.5297L14.9844 8.76624L10.2337 14.3422Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_19334_33">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </>
  );
};

export default IconKitchenTips;
